function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { compact, some, get, head, flatMap, intersectionBy, uniqBy } from 'lodash';
import { OFF_PLATFORM_REFERRALS_ONLY } from './constants';
var mapProgramsPerService = function mapProgramsPerService(programs) {
  var result = programs.reduce(function (out, program) {
    if (program.services) {
      program.services.forEach(function (serviceId) {
        var existingService = out.find(function (item) {
          return item.service === serviceId;
        });
        if (!existingService) {
          out.push({
            service: serviceId,
            programs: [program.id]
          });
        } else {
          existingService.programs.push(program.id);
        }
      });
    }
    return out;
  }, []);
  return result;
};
var buildReferral = function buildReferral(programIds, service, currentProvider, draftState) {
  var _draftState$descripti, _draftState$attachmen, _draftState$network;
  return {
    programs: [].concat(programIds).map(function (id) {
      return {
        id: id
      };
    }),
    service: {
      id: service
    },
    description: (_draftState$descripti = draftState === null || draftState === void 0 ? void 0 : draftState.description) !== null && _draftState$descripti !== void 0 ? _draftState$descripti : '',
    primaryWorker: null,
    attachments: (_draftState$attachmen = draftState === null || draftState === void 0 ? void 0 : draftState.attachments) !== null && _draftState$attachmen !== void 0 ? _draftState$attachmen : null,
    paymentAuthForm: {
      amount_requested: null,
      service_start: null,
      service_end: null,
      icd10_code: {}
    },
    network: (_draftState$network = draftState === null || draftState === void 0 ? void 0 : draftState.network) !== null && _draftState$network !== void 0 ? _draftState$network : null,
    sendingProvider: currentProvider,
    id: draftState === null || draftState === void 0 ? void 0 : draftState.id,
    state: draftState === null || draftState === void 0 ? void 0 : draftState.state,
    case: draftState === null || draftState === void 0 ? void 0 : draftState.case
  };
};
export var buildReferralsFromPrograms = function buildReferralsFromPrograms(crtb1239AdaptDraftReferralFlow, programs, currentProvider, draftState) {
  var programsByService = mapProgramsPerService(programs);
  var referrals = [];
  if (programsByService) {
    referrals = programsByService.map(function (item, idx) {
      var referral = null;
      if (crtb1239AdaptDraftReferralFlow) {
        // Draft state for only the first referral
        var firstReferral = idx === 0 ? draftState : null;
        referral = buildReferral(item.programs, item.service, currentProvider, firstReferral);
      } else {
        referral = buildReferral(item.programs, item.service, currentProvider, draftState);
      }
      return referral;
    });
  }
  return referrals;
};
export var filterProgramsReceivingReferrals = function filterProgramsReceivingReferrals(referrals) {
  return referrals.map(function (ref) {
    return _objectSpread(_objectSpread({}, ref), {}, {
      programs: ref.programs.filter(function (program) {
        var _program$status;
        return program.receiving_referrals || (program === null || program === void 0 || (_program$status = program.status) === null || _program$status === void 0 ? void 0 : _program$status.toLowerCase()) === OFF_PLATFORM_REFERRALS_ONLY;
      })
    });
  }).filter(function (ref) {
    return ref.programs.length > 0;
  });
};
export var referralIsGrouped = function referralIsGrouped(referral) {
  return referral.programs.length > 1;
};
export var programIsFunded = function programIsFunded(program) {
  return program.fee_schedule_program != null;
};
export var referralIsFunded = function referralIsFunded(referral) {
  return referral.programs.every(programIsFunded);
};
export var programIsOffPlatform = function programIsOffPlatform(program) {
  var _program$provider, _program$provider2, _program$status2;
  return !(program !== null && program !== void 0 && (_program$provider = program.provider) !== null && _program$provider !== void 0 && _program$provider.licensed) || (program === null || program === void 0 || (_program$provider2 = program.provider) === null || _program$provider2 === void 0 ? void 0 : _program$provider2.licensed) && (program === null || program === void 0 || (_program$status2 = program.status) === null || _program$status2 === void 0 ? void 0 : _program$status2.toLowerCase()) === OFF_PLATFORM_REFERRALS_ONLY;
};
export var programIsOnPlatform = function programIsOnPlatform(program) {
  var _program$provider3, _program$status3;
  return (program === null || program === void 0 || (_program$provider3 = program.provider) === null || _program$provider3 === void 0 ? void 0 : _program$provider3.licensed) && (program === null || program === void 0 || (_program$status3 = program.status) === null || _program$status3 === void 0 ? void 0 : _program$status3.toLowerCase()) !== OFF_PLATFORM_REFERRALS_ONLY;
};
export var referralIsOON = function referralIsOON(referral) {
  return some(referral.programs.map(function (program) {
    return programIsOffPlatform(program);
  }));
};
export var getReferralStatus = function getReferralStatus(referral) {
  var grouped = referralIsGrouped(referral) ? 'Grouped' : '';
  var funded = referralIsFunded(referral) ? 'Funded' : '';
  var oon = referralIsOON(referral) ? 'Off-Platform' : 'On-Platform';
  return compact([grouped, oon, funded]).join(', ');
};
export var getProgramStatusDisplay = function getProgramStatusDisplay(isReceivingReferrals, isOON) {
  if (isOON) {
    return {
      title: 'Receiving Off-Platform Referrals',
      icon: 'IconElectronsArrow',
      color: ''
    };
  }
  if (isReceivingReferrals) {
    return {
      title: 'Accepting Referrals',
      icon: 'IconCheckCircle',
      color: '#1CCA21'
    };
  }
  if (!isReceivingReferrals) {
    return {
      title: 'Not Accepting Referrals',
      icon: 'IconCrossCircle',
      color: '#E53E3E'
    };
  }
  return {
    title: '',
    icon: '',
    color: ''
  };
};
export var getReferralSubtitle = function getReferralSubtitle(referrals, selected) {
  if (selected && referralIsOON(selected)) {
    return 'The case manager will be responsible for following up with the client.';
  }
  if (referrals && referrals.length > 1 && referralIsGrouped(selected)) {
    return 'The first recipient to accept the referral will become the case manager.';
  }
  return 'The recipient will be able to accept, reject, or forward this referral.';
};
export var initializeReferralErrors = function initializeReferralErrors(referrals, pays3551AuthInSuperset, showOpenedDate) {
  var errors = {};
  referrals.map(function (referral, index) {
    if (referral) {
      var _programs$;
      var programs = referral.programs;
      var networks = filterNetworks(referral);
      var authErrors = {};
      if (pays3551AuthInSuperset && (_programs$ = programs[0]) !== null && _programs$ !== void 0 && (_programs$ = _programs$.fee_schedule_program) !== null && _programs$ !== void 0 && _programs$.authorization_required) {
        authErrors = {
          amount_requested: !referral.paymentAuthForm.amount_requested,
          service_end: !referral.paymentAuthForm.service_end,
          icd10_code: !referral.paymentAuthForm.icd10_code
        };
      }
      ;
      var missingRequiredFields = {
        description: !referral.description || referral.description.trim() === '',
        primary_worker: referralIsOON(referral) && !referral.primaryWorker,
        network: shouldShowNetworkSelect(networks, programs) && !referral.network,
        opened_date: referralIsOON(referral) && !(referral !== null && referral !== void 0 && referral.opened_date) && showOpenedDate
      };
      var combinedErrors = _objectSpread(_objectSpread({}, authErrors), missingRequiredFields);
      errors[index] = combinedErrors;
    }
    return null;
  });
  return errors;
};
export var shouldShowNetworkSelect = function shouldShowNetworkSelect() {
  var networks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var programs = arguments.length > 1 ? arguments[1] : undefined;
  return networks.length > 1 && programs.length === 1 || isUnlistedProgram(programs[0]);
};
export var generateErrorMessage = function generateErrorMessage(errors) {
  var errorCount = Object.values(errors).flatMap(Object.values).filter(Boolean).length;
  var prefix = errorCount === 1 ? '1 action item needs' : "".concat(errorCount, " action items need");
  return errorCount > 0 ? "".concat(prefix, " your attention before you can submit your referral(s).") : null;
};
export var filterNetworks = function filterNetworks(referral) {
  var sendingProvider = referral.sendingProvider,
    programs = referral.programs;
  var sendingNetworks = get(sendingProvider, 'networks');
  var receivingNetworks = flatMap(programs, function (program) {
    return get(program, 'provider.networks');
  }).filter(Boolean).filter(function (network) {
    return network.state === 'active';
  });
  if (sendingNetworks.length === 1) {
    // 1 sending network and 1+ receiving networks, return sending network
    return uniqBy(receivingNetworks.filter(function (network) {
      return network.id === head(sendingNetworks).id;
    }), 'id');
  } else if (receivingNetworks.length > 1) {
    //  2+ sending networks and 2+ receiving network, return common networks
    return intersectionBy(receivingNetworks, sendingNetworks, 'id');
  } else {
    // 2+ sending networks and 1 receiving network, return receiving network
    return receivingNetworks;
  }
};
export var hasOffPlatformReferrals = function hasOffPlatformReferrals(referrals) {
  return some(referrals === null || referrals === void 0 ? void 0 : referrals.map(function (r) {
    return referralIsOON(r);
  }));
};
export var handleKeyPress = function handleKeyPress(e, action) {
  if (['Enter', ' '].includes(e.key)) {
    action();
  }
};
export var addIdToUnlistedPrograms = function addIdToUnlistedPrograms(programs) {
  return programs.map(function (obj) {
    if (!obj.id) {
      obj.id = "unlisted_".concat(obj.name.replace(/\s+/g, '').toLowerCase(), "_").concat(obj.services);
      obj.status = OFF_PLATFORM_REFERRALS_ONLY;
    }
    return obj;
  });
};
export var addProgramToReferral = function addProgramToReferral(referrals, programs, condition) {
  referrals.forEach(function (referral) {
    referral.programs = referral.programs.map(function (p) {
      if (condition(p)) {
        var programIndex = programs.findIndex(function (program) {
          return p.id === program.id;
        });
        return programs[programIndex];
      }
      return p;
    });
  });
};
export var isUnlistedReferral = function isUnlistedReferral(referral) {
  var _referral$programs;
  return referral === null || referral === void 0 || (_referral$programs = referral.programs) === null || _referral$programs === void 0 ? void 0 : _referral$programs.every(function (p) {
    var _p$id;
    return (_p$id = p.id) === null || _p$id === void 0 ? void 0 : _p$id.startsWith('unlisted');
  });
};
export var isUnlistedProgram = function isUnlistedProgram(program) {
  var _program$id;
  return program === null || program === void 0 || (_program$id = program.id) === null || _program$id === void 0 ? void 0 : _program$id.startsWith('unlisted');
};
export var isEmptyErrors = function isEmptyErrors(errors) {
  return !Object.values(errors).flatMap(Object.values).some(Boolean);
};
export var removeErrorByIndex = function removeErrorByIndex(errors, index) {
  return Object.keys(errors).filter(function (key) {
    return Number(key) !== index;
  }).reduce(function (acc, key, newIndex) {
    acc[newIndex] = errors[key];
    return acc;
  }, {});
};
export default function selectHours(locations, providerHours) {
  var getClosestLocation = locations.find(function (loc) {
    return loc.is_closest;
  });
  var closestLocationHours = getClosestLocation === null || getClosestLocation === void 0 ? void 0 : getClosestLocation.hours;
  var organizationHours = providerHours !== null && providerHours !== void 0 ? providerHours : {};
  return closestLocationHours !== null && closestLocationHours !== void 0 ? closestLocationHours : organizationHours;
}
export var updatedReferralsBySelectedServices = function updatedReferralsBySelectedServices(referrals, selectedServices) {
  var referralsBySelectedServices = referrals.filter(function (referral) {
    return selectedServices.some(function (service) {
      return service.serviceId === referral.service.id;
    });
  });
  var updatedReferrals = referralsBySelectedServices.map(function (referral) {
    var programsBySelectedServices = referral.programs.filter(function (program) {
      return selectedServices.some(function (service) {
        return service.programId === program.id && service.serviceId === referral.service.id;
      });
    });
    return _objectSpread(_objectSpread({}, referral), {}, {
      programs: programsBySelectedServices
    });
  });
  var referralsWithPrograms = updatedReferrals.filter(function (referral) {
    return referral.programs.length > 0;
  });
  return referralsWithPrograms;
};
//# sourceMappingURL=utils.js.map